import api from "../../../api/axios";

// D2-C1 — private Deal-linked Tasks transport.
// GET /crm/tasks/?deal=<id> operates after the private Task queryset boundary.
// Does not invent Deal-wide aggregates or counterparty disclosure.

export const fetchTasksForDeal = (dealId, { signal } = {}) =>
  api
    .get("/crm/tasks/", { params: { deal: dealId }, signal })
    .then((res) => res.data);

export const unwrapTaskListPayload = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
};
